import { useState } from "react";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import {
  uploadVideoToCloudinary,
  type CloudinaryUploadResult,
} from "../lib/cloudinaryUpload";

const MAX_VIDEO_SIZE = 100 * 1024 * 1024; // 100MB

export const useVideoUpload = () => {
  const [isUploading, setIsUploading] = useState(false);
  const [progress, setProgress] = useState(0);

  const upload = async (
    file: File | null,
  ): Promise<CloudinaryUploadResult | null> => {
    if (!file) return null;

    if (!file.type.startsWith("video/")) {
      toast.error("File không phải video");
      return null;
    }
    if (file.size > MAX_VIDEO_SIZE) {
      toast.error(
        `Video quá lớn (${(file.size / 1024 / 1024).toFixed(1)}MB). Tối đa 100MB.`,
      );
      return null;
    }

    setIsUploading(true);
    setProgress(0);
    try {
      return await uploadVideoToCloudinary(file, setProgress);
    } catch (err) {
      const message =
        err instanceof AxiosError
          ? (err.response?.data?.error?.message ?? "Upload video thất bại")
          : err instanceof Error
            ? err.message
            : "Upload video thất bại";
      toast.error(message);
      return null;
    } finally {
      setIsUploading(false);
      setProgress(0);
    }
  };

  return { upload, isUploading, progress };
};
